import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo me lleva por día y cuánto dura el programa?',
  answer: 'El programa dura 7 días — un enfoque por día. Cada técnica toma entre 2 y 5 minutos. Podés hacerlas mientras tomás café, esperás el ascensor o estás en el baño. No necesitás tiempo extra — solo saber cuándo y cómo usarlas.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'De forma inmediata en tu email tras el pago. Es un producto digital, lo tenés en tu celular u ordenador en segundos.'
}, {
  question: '¿Funciona si ya probé meditación, apps y respiraciones y nada me duró?',
  answer: 'Sí — y tiene sentido que hayas llegado hasta acá con esa frustración. La mayoría de esas herramientas trabajan con tu mente. Mente en Calma trabaja con tu biología. La Maniobra del Nervio Vago y el Grounding no te piden que te relajes — le dan una orden química directa a tu sistema nervioso. Es diferente en la base.'
}, {
  question: '¿Es para mí si trabajo todo el día y no tengo tiempo?',
  answer: 'Es exactamente para eso. Cada técnica toma entre 2 y 5 minutos. Están diseñadas para hacerse en cualquier momento del día. No necesitás tiempo extra — necesitás saber cuándo y cómo usarlas.'
}, {
  question: '¿Por qué ARS 9.500 si hay cosas gratis en internet?',
  answer: 'En internet hay información. Acá hay un protocolo. La diferencia es que este sistema te dice exactamente qué hacer, en qué orden, en qué momento del día — durante 7 días seguidos. No tenés que buscar, filtrar ni probar. Solo seguir el plan.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main text-center mb-12" data-id="element-16">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-17">
            {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-xl overflow-hidden bg-card/30" data-id="element-18">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors duration-200" data-id="element-19">
                  <span className="text-lg font-semibold text-main pr-4" data-id="element-20">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.25
              }} className="shrink-0 text-warm" data-id="element-21">
                    <ChevronDownIcon size={20} data-id="element-22" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-23">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-24">
                      <p className="px-6 pb-6 text-muted leading-relaxed" data-id="element-25">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}